module.exports = __webpack_public_path__ + "img/img_案例04.41b5d4e7.png";